/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  TbPrompt,
  TbSwitchHorizontal,
  TbFolderQuestion,
  TbCircleLetterE,
  TbCircleLetterW,
} from 'react-icons/tb';
import {
  ImUsers,
  ImBooks,
} from 'react-icons/im';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  RiAdminFill,
  RiListSettingsFill,
  RiSurveyFill,
} from 'react-icons/ri';
import { GrResources } from 'react-icons/gr';
import {
  PiProjectorScreenChartFill,
  PiNoteFill,
  PiExamFill,
} from 'react-icons/pi';
import {
  BiExport,
  BiSolidContact,
} from 'react-icons/bi';
import { VscSymbolString } from 'react-icons/vsc';
import { TfiLayoutListThumbAlt } from 'react-icons/tfi';
import {
  GiTeacher,
  GiProgression,
  GiBookshelf,
} from 'react-icons/gi';
import {
  FaUsersLine,
  FaClipboardQuestion,
} from 'react-icons/fa6';
import {
  FaListUl,
  FaChalkboardTeacher,
  FaSchool,
  FaArchive,
  FaComment,
  FaListOl,
  FaBookOpen,
  FaUserTie,
  FaTv,
  FaFileSignature,
  FaRegCalendarAlt,
  FaRegCalendarCheck,
} from 'react-icons/fa';

import {
  MdSchool,
  MdConnectedTv,
  MdOutlineQuestionMark,
  MdOutlineClass,
  MdOutlineMoveUp,
  MdOutlinePointOfSale,
  MdSubject,
} from 'react-icons/md';
import { CiMail } from 'react-icons/ci';
import {
  GoContainer,
} from 'react-icons/go';
import { Badge } from '@material-ui/core';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { studentServices } from '../../../redux/services/studentServices';

const SidebarContent = ({ user }) => {
  const [nbRepeatRequests, setNbRepeatRequests] = useState(0);
  const linkColor = user && user.themeColor ? `rgba(${user.themeColor.r}, ${user.themeColor.g}, ${user.themeColor.b})` : '#e9e9e9';
  const linkReverseColor = user && user.themeColor ? `rgba(${255 - user.themeColor.r}, ${255 - user.themeColor.g}, ${255 - user.themeColor.b}, ${1})` : '#333333';

  const fetchRepeatRequests = async () => {
    const res = await studentServices.getRepeatStudents();
    if (res && !res.error) {
      setNbRepeatRequests(res.length);
    }
  };

  useEffect(() => {
    fetchRepeatRequests();
  }, []);

  return (
    <div className="sidebar__content">
      <ul className="sidebar__block">
        <SidebarCategory title="Logs" linkColor={linkColor} linkReverseColor={linkReverseColor} icon={<TbPrompt size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            title="English World"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<TbCircleLetterE size={16} style={{ marginBottom: 50 }} />}
            route="/notificationsIntraEW"
          />
          <SidebarLink
            title="Medical World"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<TbCircleLetterW size={16} style={{ marginBottom: 50 }} />}
            route="/notificationsIntra"
          />
          <SidebarLink
            title="Connexion attempts"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<MdConnectedTv size={16} style={{ marginBottom: 50 }} />}
            route="/connexions"
          />
        </SidebarCategory>
        <SidebarLink
          title="Presential groups"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={<MdOutlineMoveUp size={16} />}
          route="/presential-groups"
        />
        <SidebarCategory linkColor={linkColor} linkReverseColor={linkReverseColor} title="Notifications" icon={<FaComment size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Notifications Students"
            route="/notifications"
            icon={<MdSchool size={16} style={{ marginBottom: 50 }} />}
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Notifications Clients"
            route="/notifClients"
            icon={<FaUserTie size={16} style={{ marginBottom: 50 }} />}
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Notifications Mail"
            route="/notificationsMail"
            icon={<CiMail size={16} style={{ marginBottom: 50 }} />}
          />
        </SidebarCategory>
        <SidebarCategory title="Clients" linkColor={linkColor} linkReverseColor={linkReverseColor} icon={<FaSchool size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            title="English World"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<TbCircleLetterE size={16} style={{ marginBottom: 50 }} />}
            route="/companyall/1"
          />
          <SidebarLink
            title="Medical World"
            icon={<TbCircleLetterW size={16} style={{ marginBottom: 50 }} />}
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            route="/companyall/2"
          />
          <SidebarLink
            title="Phone Book"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<BiSolidContact size={16} style={{ marginBottom: 50 }} />}
            route="/phonebook"
          />
        </SidebarCategory>
        <SidebarCategory title="Users" linkColor={linkColor} linkReverseColor={linkReverseColor} icon={<FaUsersLine size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            title="Admin"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<RiAdminFill size={16} style={{ marginBottom: 50 }} />}
            route="/admin"
          />
          <SidebarLink
            title="Client contact"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<ImUsers size={16} style={{ marginBottom: 50 }} />}
            route="/customers"
          />
          <SidebarLink
            title="Students"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<MdSchool size={16} style={{ marginBottom: 50 }} />}
            route="/students"
          />
          <SidebarLink
            title="Trainers"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<GiTeacher size={16} style={{ marginBottom: 50 }} />}
            route="/teachers"
          />
          <SidebarLink
            title="Sales"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<MdOutlinePointOfSale size={16} style={{ marginBottom: 50 }} />}
            route="/sales"
          />
        </SidebarCategory>
        <SidebarCategory
          title="Edusign"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={(
            <FaFileSignature
              size={16}
              style={{ marginBottom: 50 }}
            />
          )}
        >
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Absences"
            icon={<FaClipboardQuestion size={16} style={{ marginBottom: 50 }} />}
            route="/edusign/absences"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Planning"
            icon={<FaRegCalendarAlt size={16} style={{ marginBottom: 50 }} />}
            route="/edusign/planning"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Formations"
            icon={<FaRegCalendarCheck size={16} style={{ marginBottom: 50 }} />}
            route="/edusign/ending-formations"
          />
        </SidebarCategory>
        <SidebarCategory title="Program" linkColor={linkColor} linkReverseColor={linkReverseColor} icon={<ImBooks size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Courses"
            icon={<RiListSettingsFill size={16} style={{ marginBottom: 50 }} />}
            route="/courses"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Modules"
            icon={<GoContainer size={16} style={{ marginBottom: 50 }} />}
            route="/modules"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Units"
            icon={<PiProjectorScreenChartFill size={16} style={{ marginBottom: 50 }} />}
            route="/units"
          />
          <SidebarLink
            title="Books"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<GiBookshelf size={16} style={{ marginBottom: 50 }} />}
            route="/books"
          />
          <SidebarLink
            title="Resources"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<GrResources size={16} style={{ marginBottom: 50 }} />}
            route="/resources"
          />
        </SidebarCategory>
        <SidebarCategory title="E-learning" linkColor={linkColor} linkReverseColor={linkReverseColor} icon={<FaChalkboardTeacher size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            title="Progress"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<GiProgression size={16} style={{ marginBottom: 50 }} />}
            route="/progress"
          />
          <SidebarLink
            title="Semesters"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<FaListOl size={16} style={{ marginBottom: 50 }} />}
            route="/semesters"
          />
          <SidebarLink
            title="Exports"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<BiExport size={16} style={{ marginBottom: 50 }} />}
            route="/exports"
          />
        </SidebarCategory>
        <SidebarCategory title="Exams" linkColor={linkColor} linkReverseColor={linkReverseColor} icon={<PiExamFill size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="List"
            icon={<FaListUl size={16} style={{ marginBottom: 50 }} />}
            route="/list"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Quiz"
            icon={<PiNoteFill size={16} style={{ marginBottom: 50 }} />}
            route="/quiz"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Subjects"
            icon={<MdSubject size={16} style={{ marginBottom: 50 }} />}
            route="/exam-subjects"
          />
        </SidebarCategory>
        <SidebarCategory linkColor={linkColor} linkReverseColor={linkReverseColor} title="Placement Test" icon={<FaBookOpen size={16} style={{ marginBottom: 50 }} />}>
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            color="red"
            title="Codes"
            icon={<VscSymbolString size={16} style={{ marginBottom: 50 }} />}
            route="/codes"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Placement Results"
            icon={<MdOutlineClass size={16} style={{ marginBottom: 50 }} />}
            route="/placement/results"
          />
          <SidebarLink
            title="Tests Listing"
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            icon={<TfiLayoutListThumbAlt size={16} style={{ marginBottom: 50 }} />}
            route="/placementTestList"
          />
          <SidebarLink
            linkColor={linkColor}
            linkReverseColor={linkReverseColor}
            title="Questions"
            icon={<MdOutlineQuestionMark size={16} style={{ marginBottom: 50 }} />}
            route="/questions"
          />
        </SidebarCategory>
        <SidebarLink
          title="Repeat requests"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={(
            <Badge badgeContent={nbRepeatRequests} color="secondary" variant="dot">
              <TbSwitchHorizontal size={16} style={{ marginBottom: 50 }} />
            </Badge>
          )}
          route="/repeat"
        />
        <SidebarLink
          title="Student transfers"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={<MdOutlineMoveUp size={16} />}
          route="/transfers"
        />
        <SidebarLink
          title="Satisfaction"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={<RiSurveyFill size={16} />}
          route="/surveys"
        />
        <SidebarLink
          title="Archives"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={<FaArchive size={16} />}
          route="/archive/students"
        />
        <SidebarLink
          title="Webinaire"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={<FaTv size={16} />}
          route="/webinaire"
        />
      </ul>
    </div>
  );
};

function mapState(state) {
  const { user } = state.user;
  return {
    user,
  };
}

export default withRouter(connect(mapState)(SidebarContent));
